import { Dispatch } from "redux";
import { thinkApi } from "../../Api/Microservices";
import { RecentArchieveConversation } from "../../Models/ConversationApiState";
import { ArchievedRequest } from "../../Models/Request/SASUrlRequest";
import { buildAppError } from "../../Utils/AppError";
import {
  ADD_RECENT_CONVERSATION_STATE,
  FETCH_ARCHIEVE_CONVERSATION_FAILURE,
  FETCH_ARCHIEVE_CONVERSATION_REQUEST,
  FETCH_ARCHIEVE_CONVERSATION_SUCCESS,
  FETCH_RECENT_CONVERSATION_FAILURE,
  FETCH_RECENT_CONVERSATION_REQUEST,
  FETCH_RECENT_CONVERSATION_SUCCESS,
  MARK_ARCHIEVE_CONVERSATION_AS_RECENT_FAILURE,
  MARK_ARCHIEVE_CONVERSATION_AS_RECENT_REQUEST,
  MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS,
  MARK_RECENT_CONVERSATION_AS_ARCHIEVE_FAILURE,
  MARK_RECENT_CONVERSATION_AS_ARCHIEVE_REQUEST,
  MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS,
  UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS,
  UPDATE_CONVERSATION_TITLE_FAILURE,
  UPDATE_CONVERSATION_TITLE_REQUEST,
  UPDATE_CONVERSATION_UPDATEDDATE,
  UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE,
  UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS,
} from "./ConverasationType";

const setAuthorizationHeader = (token: any) => {
  thinkApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const fetchArchieveConversationRequest = () => ({
  type: FETCH_ARCHIEVE_CONVERSATION_REQUEST,
});

export const fetchArchieveConversationSuccess = (value: any) => ({
  type: FETCH_ARCHIEVE_CONVERSATION_SUCCESS,
  payload: value,
});

export const fetchArchieveConversationFailure = (error: any) => ({
  type: FETCH_ARCHIEVE_CONVERSATION_FAILURE,
  payload: error,
});

export const fetchRecentConversationRequest = () => ({
  type: FETCH_RECENT_CONVERSATION_REQUEST,
});

export const fetchRecentConversationSuccess = (value: any) => ({
  type: FETCH_RECENT_CONVERSATION_SUCCESS,
  payload: value,
});

export const fetchRecentConversationFailure = (error: any) => ({
  type: FETCH_RECENT_CONVERSATION_FAILURE,
  payload: error,
});

export const markAsRecentRequest = () => ({
  type: MARK_ARCHIEVE_CONVERSATION_AS_RECENT_REQUEST,
});

export const markAsRecentSuccess = (conversationId: any) => ({
  type: MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS,
  payload: conversationId,
});

export const markAsRecentFailure = (error: any) => ({
  type: MARK_ARCHIEVE_CONVERSATION_AS_RECENT_FAILURE,
  payload: error,
});

export const markAsArchieveRequest = () => ({
  type: MARK_RECENT_CONVERSATION_AS_ARCHIEVE_REQUEST,
});

export const markAsArchieveSuccess = (conversationId: any) => ({
  type: MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS,
  payload: conversationId,
});

export const markAsArchieveFailure = (error: any) => ({
  type: MARK_RECENT_CONVERSATION_AS_ARCHIEVE_FAILURE,
  payload: error,
});

export const updateConversationTitleRequest = () => ({
  type: UPDATE_CONVERSATION_TITLE_REQUEST,
});

export const updateRecentConversationTitleSuccess = (conversationId: any) => ({
  type: UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS,
  payload: conversationId,
});

export const updateArchieveConversationTitleSuccess = (
  conversationId: any
) => ({
  type: UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS,
  payload: conversationId,
});

export const updateConversationTitleFailure = (error: any) => ({
  type: UPDATE_CONVERSATION_TITLE_FAILURE,
  payload: error,
});

export const updateRecentConversation = (value: RecentArchieveConversation) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: ADD_RECENT_CONVERSATION_STATE, payload: value });
  };
};

export const updateRecentConversationIfNotPresent = (value: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE,
      payload: value,
    });
  };
};

export const updateConversationupdatedDate = (value: string | undefined) => {
  return async (dispatch: Dispatch) => {
    if (value) {
      dispatch({ type: UPDATE_CONVERSATION_UPDATEDDATE, payload: value });
    }
  };
};

export const markConversationRecent = (token: any, value: ArchievedRequest) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(markAsRecentRequest());
      try {
        setAuthorizationHeader(token);
        await thinkApi.post(`/conversation/isarchieved`, value);
        dispatch(markAsRecentSuccess(value.ConversationId));
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(markAsRecentFailure(appError.message));
      }
    }
  };
};

export const markConversationArchieve = (
  token: any,
  value: ArchievedRequest
) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(markAsArchieveRequest());
      try {
        setAuthorizationHeader(token);
        await thinkApi.post(`/conversation/isarchieved`, value);
        dispatch(markAsArchieveSuccess(value.ConversationId));
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(markAsArchieveFailure(appError.message));
      }
    }
  };
};

export const fetchConversation = (token: any, value: boolean) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(
        value
          ? fetchArchieveConversationRequest()
          : fetchRecentConversationRequest()
      );
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.get(`/conversations/${value}`);
        dispatch(
          value
            ? fetchArchieveConversationSuccess(response.data)
            : fetchRecentConversationSuccess(response.data)
        );
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(
          value
            ? fetchArchieveConversationFailure(appError.message)
            : fetchRecentConversationFailure(appError.message)
        );
      }
    }
  };
};

export const updateConversationTitle = (
  token: any,
  value: RecentArchieveConversation,
  type: boolean
) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(updateConversationTitleRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.post(
          `/conversation/update/conversationtitle`,
          value
        );
        dispatch(
          type
            ? updateArchieveConversationTitleSuccess(response.data)
            : updateRecentConversationTitleSuccess(response.data)
        );
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(updateConversationTitleFailure(appError.message));
      }
    }
  };
};
